module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "bg bg1"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg bg2"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h2', [_vm._v("Christmas Workshops for Groups or Teams")]), _vm._v(" "), _vm._m(0), _c('div', {
    staticClass: "action"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Christmas'
      }
    }
  }, [_vm._v("Find out more")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Looking for workshops for your team or a group of friends? Contact us at "), _c('a', {
    attrs: {
      "href": "mailto:learn@hatopress.net?subject=Christmas+Group+Workshop"
    }
  }, [_vm._v("learn@hatopress.net")]), _vm._v(" or find out what we're offering"), _c('br'), _c('br')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a417685a","transformToRequire":{"img":"src","audio":"src","video":"poster"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Christmas.vue
// module id = 223
// module chunks = 1